import React from 'react'
import { observer, inject } from 'mobx-react'
import { Avatar, Icon } from 'components/misc'
import { MODES } from 'core/constants'

const MobileThumb = ({ toggleOpen, store, options }) => {
  const { mobileIcon } = options.urls
  const { newMessage = '' } = options.translations.basic
  const { mode } = options;
  const unread = store.visibleConversations.reduce((total, c) => total + c.unreadByMeCount, 0)
  const msg = newMessage ? newMessage.replace('{count}', unread) : unread

  if (mode === MODES.CHAT_LIST) {
    const iconToRender =  unread ? 'ureeadIcon' : 'chatIcon'
    return (
      <div className={`chat-widget-mobile-thumb ${mobileIcon ? 'mobile-icon' : ''} ${newMessage ? 'with-popup' : ''} ${mode}-mode`} onClick={toggleOpen}>
      <Icon iconName={iconToRender}/>
      {unread && <span className={`unread ${newMessage ? 'popup' : 'badge' }`}>{msg}</span>}
    </div>
    )
  }

  return (
    <div className={`chat-widget-mobile-thumb ${mobileIcon ? 'mobile-icon' : ''} ${newMessage ? 'with-popup' : ''}`} onClick={toggleOpen}>
      {mobileIcon ? <img src={mobileIcon}/> : <Avatar user={store.conversation.otherUserProfile}/>}
      {unread && <span className={`unread ${newMessage ? 'popup' : 'badge' }`}>{msg}</span>}
    </div>
  )
}

export default inject('store')(observer(MobileThumb))
